module.exports = __webpack_public_path__ + "static/media/shapes-paths.1.9ff29e25.svg";